export default {"src":"/_next/static/media/icons-close.75dfe347.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};